import React from 'react';
import {View, Modal, TouchableOpacity, StyleSheet} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton/CCButton';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';

interface CoachScreenModalProps {
  visible: boolean;
  onClose: () => void;
  onNormalWindow: () => void;
  onFloatingWindow: () => void;
  isPipSupported: boolean;
  browserName: string;
  browserVersion: number;
}

export const CoachScreenModal: React.FC<CoachScreenModalProps> = ({
  visible,
  onClose,
  onNormalWindow,
  onFloatingWindow,
  isPipSupported,
  browserName,
  browserVersion,
}) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}>
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <View style={styles.modalHeader}>
            <View style={{flex: 1}}>
              <CCText fontWeight="bold" fontSize={FontSizes[16]}>
                Choose how to open the coach screen
              </CCText>
            </View>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <CCText style={styles.closeButtonText}>×</CCText>
            </TouchableOpacity>
          </View>

          <View style={styles.modalBody}>
            <Icon
              name="video-call"
              size={60}
              color={CCColors.Primary.Dark}
              style={{alignSelf: 'center', marginVertical: 20}}
            />

            <View style={styles.buttonContainer}>
              <CCButton
                style={styles.actionButton}
                hoverEffect={false}
                onPress={onNormalWindow}>
                <CCText color={CCColors.White} fontWeight="medium">
                  Inside Caissa
                </CCText>
              </CCButton>

              <CCButton
                style={[
                  styles.actionButton,
                  styles.secondaryButton,
                  !isPipSupported && styles.disabledButton,
                ]}
                hoverEffect={false}
                onPress={onFloatingWindow}
                disabled={!isPipSupported}>
                <CCText
                  color={
                    isPipSupported ? CCColors.Primary.Dark : CCColors.Black
                  }
                  fontWeight="medium">
                  Floating Window
                </CCText>
              </CCButton>

              {!isPipSupported && (
                <CCText
                  fontSize={FontSizes[12]}
                  color={CCColors.Grey.Grey}
                  style={{textAlign: 'center', marginTop: 8}}>
                  {browserName === 'Chrome' || browserName === 'Microsoft Edge'
                    ? `Floating Window requires ${browserName} version 116+. You are using version ${browserVersion}.`
                    : `Floating Window not available in ${browserName}. Please use Chrome or Edge browser (version 116+).`}
                </CCText>
              )}
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    width: '90%',
    maxWidth: 500,
    backgroundColor: '#fff',
    padding: 24,
    borderRadius: 10,
    elevation: 10,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  closeButton: {
    padding: 4,
  },
  closeButtonText: {
    fontSize: 32,
    fontWeight: 'bold',
    color: CCColors.Grey.Grey,
    lineHeight: 32,
  },
  modalBody: {
    alignItems: 'center',
  },
  buttonContainer: {
    width: '100%',
    gap: 12,
    marginTop: 10,
  },
  actionButton: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 8,
    width: '100%',
  },
  secondaryButton: {
    backgroundColor: CCColors.White,
    borderWidth: 1,
    borderColor: CCColors.Primary.Dark,
  },
  disabledButton: {
    backgroundColor: CCColors.Grey.Grey,
    borderColor: CCColors.Grey.Grey,
    opacity: 0.5,
  },
});
